declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '26904114352525543'
const HOTMART_BASE_URL = 'https://pay.hotmart.com/S105541783F'
const PRODUCT_VALUE = 14.0
const CURRENCY = 'USD'

function getUtms() {
  const urlParams = new URLSearchParams(window.location.search)
  return {
    source: urlParams.get('utm_source') || 'directo',
    medium: urlParams.get('utm_medium') || 'none',
    campaign: urlParams.get('utm_campaign') || 'organico',
    content: urlParams.get('utm_content') || 'sin_contenido',
    term: urlParams.get('utm_term') || 'sin_termino',
    fbclid: urlParams.get('fbclid') || '',
  }
}

function getCookie(name: string): string {
  const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : ''
}

function getSrcValue() {
  const utms = getUtms()
  return `${utms.source}|${utms.medium}|${utms.campaign}|${utms.content}|${utms.term}`.substring(
    0,
    100,
  )
}

export function decorateHotmartLinks() {
  const utms = getUtms()
  const srcValue = getSrcValue()
  const fbp = getCookie('_fbp')
  const fbc = getCookie('_fbc') || utms.fbclid

  const allLinks = document.querySelectorAll('a')
  allLinks.forEach((link) => {
    if (link.href.includes('pay.hotmart.com')) {
      const newUrl = new URL(HOTMART_BASE_URL)
      newUrl.searchParams.set('checkoutMode', '10')
      newUrl.searchParams.set('src', srcValue)
      newUrl.searchParams.set('sck', srcValue)
      if (fbp) newUrl.searchParams.set('fbp', fbp)
      if (fbc) newUrl.searchParams.set('fbc', fbc)
      link.href = newUrl.toString()
    }
  })
}

export function initMetaPixel() {
  if (window.fbq) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const s = document.getElementsByTagName('script')[0]
  s?.parentNode?.insertBefore(t, s)

  // Noscript fallback
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  document.body.appendChild(img)

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
  window.fbq('track', 'ViewContent')

  // Decorate links on init and after a delay for dynamic elements
  decorateHotmartLinks()
  setTimeout(decorateHotmartLinks, 2000)
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart')
  }
}

export function trackInitiateCheckout() {
  if (window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      value: PRODUCT_VALUE,
      currency: CURRENCY,
      content_name: 'Pack Scaloneta 2026',
      content_category: 'Digital Product',
    })
  }
}
